module.exports = __webpack_public_path__ + "img/alldone-icon.39427fa9.svg";